import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./TradeSetup.css";
import SearchView from "../../widgets/SearchView";
import TradeSetupSearchForm from './TradeSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import CardLayout from '../../widgets/Card';
import { ViewContainer } from "./../../View.jsx";

const utils = new ViewUtils();
const headCells = [
    { id: 'TradeID', numeric: false, disablePadding: true, label: 'Artisan ID' },
    { id: 'TradeTitle', numeric: false, disablePadding: true, label: 'Artisan Title' }
];

class TradeSetupSearch extends Component {

    constructor(props) {
        super(props)

        let model = {
            TradeID: "",
            TradeTitle: ""
        }

        this.searchParameters = !utils.isNull(this.props.programmeId) ?
            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "TradeID", Value: "" },
                { Name: "TradeTitle", Value: "" }
            ]
            :
            [
                { Name: "TradeID", Value: "" },
                { Name: "TradeTitle", Value: "" },
            ]

        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }

        if (!utils.isNull(props.personId)) {
            model.PersonID = props.personId;
            this.searchParameters.push({ Name: "PersonID", Value: props.personId })
        }

        this.state = {
            model: model,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon' },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true },
                        { id: "delete", label: "", tooltip: "Remove Trade", icon: "DeleteIcon", disabled: true}
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }


    render() {
        return (
            <ViewContainer title={utils.isNull(this.props.showTitle) || this.props.showTitle === true ? 'Trades' : null}>
                <SearchView headCells={headCells} 
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/TradeSetup/GetSearch"}
                    entityViewPath='/TradeSetup'
                    model={this.state.model} toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="TradeTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch} history={this.props.history}
                    multiSelect={this.props.multiSelect} selectionCallbackMode={this.props.selectionCallbackMode}
                    deleteUrl={"api/sims/TradeSetup/unlinkTrade"}
                    promptTitle={"Remove Trade"}
                    promptContent={"Removing the Trade is a permanent action and the Trade will not be available going forward. Are you sure you want to remove this Trade?"}
                >
                    <TradeSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView> 
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(TradeSetupSearch)
);
